// src/features/TptStaticData/table.tsx
import { Table } from "../../features/Table";
import { type TptStaticData, tpt_static_data_columns } from "./columns";
import { FilterTptStaticData } from "./filter";
import { useLocation } from "react-router-dom";

const client = "instit-quantilia";
const table_name = "tpt_static_data";

export const TptStaticDataTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<TptStaticData, TptStaticData>
      label="TPT Static Data"
      client={client}
      table_name={table_name}
      columns={tpt_static_data_columns}
      disable_translations_request={true}
      filter={<FilterTptStaticData />}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
